__turbopack_context__.v({
  "card": "BrandCard-module-scss-module__QkzqcW__card",
  "ctaWrapper": "BrandCard-module-scss-module__QkzqcW__ctaWrapper",
  "image": "BrandCard-module-scss-module__QkzqcW__image",
  "imageWrapper": "BrandCard-module-scss-module__QkzqcW__imageWrapper",
  "logo": "BrandCard-module-scss-module__QkzqcW__logo",
  "logoImage": "BrandCard-module-scss-module__QkzqcW__logoImage",
  "overlay": "BrandCard-module-scss-module__QkzqcW__overlay",
});
